<template>
  <div class="modal"
       id="upload_model"
       tabindex="-1"
       role="dialog"
       aria-hidden="true">
    <div class="modal-dialog modal-sm"
         role="document">
      <div class="modal-content">
        <div class="modal-body">
          <h3>{{ objUpdatedVer.Device }} Unit
            <span>{{ objUpdatedVer.PartName }}</span>
          </h3>
          <img :src="imgOfPartNo" alt="">
          <div class="state_run" :class="updateStyle">
            <p>{{ updatedMsg }}</p>
            <div class="progress" v-show="showProgress">
              <div class="progress-bar"
                  role="progressbar"
                  aria-valuenow="60"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  :style="{width: progress + '%'}">
              </div>
            </div>
            <p>{{ result }}</p>
          </div>
        </div>
        <div class="modal-footer" v-show="statusBtn">
          <button
            id = "btnOK"
            type="button"
            class="btn btn-lg mb20 btn_normalBtn"
            data-dismiss="modal"
            @click="funcCloseModal"
          >
            {{ statusText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { allowPartNo, funcOriginalPartNo } from '@/utils/allowPartNo';

export default {
  name: 'UpdateModal',
  props: ['objUpdatedVer', 'objUpdatedMsg'],
  data () {
    return {
      progress: 0,
      successful: 0,
      updatedMsg: '',
      updateStyle: 'state_success'
    };
  },
  watch: {
    objUpdatedMsg (data) {
      if (data.Status === 1000) {
        this.updateStyle = 'state_success';
        this.updatedMsg = this.$t('update.table.updateModal.success');
        this.progress = 100;
      } else if (data.Status === 1001) {
        this.updateStyle = 'state_failed';
        this.updatedMsg = '[' + data.ErrorCode + ']' + this.$t('update.table.updateModal.failed');
        if (data.ErrorCode === 30001) {
          this.updatedMsg = this.$t('update.table.updateModal.connectDongle');
        }
      } else if (data.Status === 1201) {
        this.updateStyle = 'state_success';
        this.updatedMsg = this.$t('update.table.updateModal.updating');
        this.progress = data.Progress;
      } else if (data.Status === 1200) {
        this.updatedMsg = this.$t('update.table.updateModal.ready');
      }
    }
  },
  computed: {
    ...mapGetters({
      getDeviceInfo: 'bikeConnect/getDeviceInfo'
    }),
    /** 用 ConsolePN 找到對應的圖片 */
    imgOfPartNo () {
      if (this.objUpdatedVer.PartNO) {
        // console.log('this.objUpdatedVer.PartNO', this.objUpdatedVer.PartNO)
        const oriPN = funcOriginalPartNo(this.objUpdatedVer.PartNO);
        if (allowPartNo[oriPN]) {
          const photo = allowPartNo[oriPN].photo;
          return require(`@/assets/images/diagnosis/${photo}`);
        } else {
          return require(`@/assets/images/diagnosis/no_image.jpg`);
        }
      } else {
        return require(`@/assets/images/diagnosis/no_image.jpg`);
      }
    },
    showProgress () {
      if (this.objUpdatedMsg.Status === 1000) return true;
      return this.objUpdatedMsg.Progress > 0;
    },
    statusBtn () {
      if (this.objUpdatedMsg.Status === 1001 && this.objUpdatedMsg.ErrorCode === 30001) return false;
      return this.objUpdatedMsg.Status === 1000 || this.objUpdatedMsg.Status === 1001;
    },
    statusText () {
      if (this.objUpdatedMsg.Status === 1000) return this.$t('update.table.updateModal.btnOk');
      else if (this.objUpdatedMsg.Status === 1001) return this.$t('update.table.updateModal.btnCancel');
      else return '';
    },
    result () {
      return this.progress + '%';
    },
    resultText () {
      if (this.objUpdatedMsg.Progress === 100) {
        return 'Complete';
      } else {
        return '';
      }
    }
  },
  methods: {
    funcCloseModal () {
      // 關閉modal，發出自定義事件來告訴父組件
      this.$emit('hide', 'close');
      this.progress = 0;
      this.updatedMsg = '';
      this.updateStyle = 'state_success';
      this.hideFooter = false;
    },
    prepareToExit () {
      let msg = this.$t('update.table.updateModal.confirmMsg');
      const answer = window.confirm(msg);
      return answer;
    }
  }
};
</script>

<style lang="scss" scoped>
  #upload_model {
    .modal-open {
      overflow: hidden;

      .modal {
        overflow-x: hidden;
        overflow-y: auto;
      }
    }

    .modal {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1050;
      display: none;
      overflow: hidden;
      outline: 0;
    }

    .modal-dialog {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      margin: 0;
    }

    .modal-scrollbar-measure {
      position: absolute;
      top: -9999px;
      width: 50px;
      height: 50px;
      overflow: scroll;
    }

    .modal-content {
      position: absolute;
      background-color: $white;
      background-clip: padding-box;
      border-radius: 2px;
      outline: 0;
      border: 1px solid rgba(0, 0, 0, 0.2);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
      display: flex;
      flex-direction: column;
      left: 50%;
      top: 50%;
      right: auto;
      min-height: 300px;
      max-height: 84vh;
      width: 90%;
      max-width: 600px;
      transform: translate(-50%, -50%);
    }

    .modal-body {
      position: relative;
      flex-grow: 100;
      padding: 15px;
      overflow: auto;

      .container {
        max-width: 500px;
        margin: 0 auto;
      }
    }

    .modal-footer {
      border-top: 0;
      text-align: center;
      padding: 7.5px;

      &::after {
        display: block;
        content: "";
        clear: both;
      }
    }

    .modal-sm {
      .modal-body {
        padding: 45px;
        @include nb-width {
          padding: 24px 40px;
        }
        >h3 {
          @include nb-width {
            @include fluid-type(26px, 32px, 1200px, 1366px);
            margin-top: 8px;
            margin-bottom: 0;
          }
        }
      }

      .modal-content {
        min-height: 200px;
        max-height: 84vh;
        max-width: 500px;
      }
    }
  }
</style>
